
import { defineComponent } from 'vue';
import IconPoint from "@/components/icons/IconPoint.vue";
import CubeList from "@/components/CubeList.vue";

export default defineComponent({
  name: 'BenefitsSection',
  components: {
    IconPoint,
    CubeList
  }
});
